import { Address } from '@anyx/shared-utils';

export const RegionDisplay = ({ address }: { address: Address; hasPrevious: boolean }) => {
  return address?.province ? <span>{address?.province}</span> : null;
};
